import React, { Fragment, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import Column from '@components/column'
import Tab from '@components/tabs'
import Title from '@components/title'
import RuleForm from './rule-form'
import { GeneralSetting } from '@apis/index'

const RulesOfGames = () => {
  const dispatch = useDispatch()
  const [activeTab, setActiveTab] = useState(0)

  const items = [
    {
      label: 'Admin Rules',
      component: RuleForm,
      props: {
        title: 'Admin',
        isActive: activeTab === 0,
      },
      onActive: () =>
        GeneralSetting.getByGroup({
          id: 'admin-rule',
          state: 'adminRules',
        }),
    },
    {
      label: 'Player Rules',
      component: RuleForm,
      props: {
        title: 'Player',
        isActive: activeTab === 1,
      },
      onActive: () =>
        GeneralSetting.getByGroup({
          id: 'player-rule',
          state: 'playerRules',
        }),
    },
  ]

  useEffect(() => {
    items[activeTab]?.onActive?.()
  }, [activeTab])

  const handleTabChange = (index: number) => {
    setActiveTab(index)
  }

  return (
    <Fragment>
      <Column>
        <Title textone="Game Management >" texttwo="Rules of Matchtoom" />
        <Tab
          items={items}
          onTabChange={handleTabChange}
          activeIndex={activeTab}
        />
      </Column>
    </Fragment>
  )
}

export default RulesOfGames
